<script lang="ts">
  interface Props {
    size?: number;
    circleFill?: string;
    [key: string]: any;
  }

  let { size = 16, circleFill = "var(--color-mono-100)", ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <circle cx="10.5" cy="5.5" r="4.5" fill="currentColor" />
  <path
    d="M2 15H4.29289C4.4255 15 4.55268 14.9473 4.64645 14.8536L5.54483 13.9552C5.6717 13.8283 5.72086 13.6432 5.67365 13.4701L5.23023 11.8442C5.12843 11.4709 5.47092 11.1284 5.84417 11.2302L7.47006 11.6737C7.64317 11.7209 7.8283 11.6717 7.95517 11.5448L9.20711 10.2929C9.39464 10.1054 9.649 10 9.91421 10H10.5L6 5.5V6.58579C6 6.851 5.89464 7.10536 5.70711 7.29289L1 12V14C1 14.5523 1.44772 15 2 15Z"
    fill="currentColor"
  />
  <circle cx="10.5" cy="5.5" r="1.5" fill={circleFill} />
</svg>
